var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDoubleUpArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 17.63 16.53",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "m17.27 16.22c-.46.42-1.19.4-1.61-.06l-6.01-6.47c-.44-.48-1.21-.48-1.67 0l-6.01 6.47c-.42.46-1.15.48-1.61.06-.46-.42-.48-1.15-.06-1.61l7.68-8.25c.44-.48 1.21-.48 1.67 0l7.68 8.26c.42.46.4 1.19-.06 1.61z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m17.27 10.22c-.46.42-1.19.4-1.61-.06l-6.01-6.47c-.44-.48-1.21-.48-1.67 0l-6.01 6.48c-.42.46-1.15.48-1.61.06-.46-.42-.48-1.15-.06-1.61l7.68-8.26c.44-.48 1.21-.48 1.67 0l7.68 8.26c.42.46.4 1.19-.06 1.61z"
}))));
export default SvgDoubleUpArrow;